import PhotoPreview from "./PhotoPreview";
import PhotoReview from "./PhotoReview";
import PhotoReject from "./PhotoReject";
import SelfieAccepted from "./SelfieAccepted";
import { PhotoUploadPayload } from "../../../types";

type Props = {
  step: string;
  base64Photo: string;
  handlePhotoUploadComplete?: (data: PhotoUploadPayload) => void;
  handlePhotoAccept: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handlePhotoBoothClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleFileChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    callback: (data: PhotoUploadPayload) => void
  ) => void;
  photoType?: string;
  isServiceError: boolean;
};

const SelfieModerationSteps = ({
  step = "",
  base64Photo,
  handlePhotoUploadComplete,
  handlePhotoAccept,
  handleFileChange,
  handlePhotoBoothClick,
  photoType,
  isServiceError
}: Props) => {
  if (!["selfie_review", "selfie_rejected", "selfie_accepted"].includes(step)) return null;

  return (
    <>
      <PhotoReview
        visible={step === "selfie_review"}
        photoType={photoType}
        handleFileChange={(e) => handleFileChange(e, handlePhotoUploadComplete)}
        handlePhotoAccept={handlePhotoAccept}>
        <PhotoPreview base64Photo={base64Photo} />
      </PhotoReview>

      <PhotoReject
        visible={step === "selfie_rejected"}
        photoType={photoType}
        isServiceError={isServiceError}
        handleFileChange={(e) => handleFileChange(e, handlePhotoUploadComplete)}
        handlePhotoBoothClick={handlePhotoBoothClick}>
        <PhotoPreview base64Photo={base64Photo} />
      </PhotoReject>

      <SelfieAccepted visible={step === "selfie_accepted"}>
        <PhotoPreview base64Photo={base64Photo} />
      </SelfieAccepted>
    </>
  );
};

export default SelfieModerationSteps;
